/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrowseResponse } from '../models/BrowseResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BrowseService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get Browse structure
     * Returns complete browse structure by Country and Language
     * @returns BrowseResponse Ok
     * @throws ApiError
     */
    public browseStructure({
        country,
        language,
    }: {
        country: string,
        language: string,
    }): CancelablePromise<BrowseResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/browse',
            query: {
                'country': country,
                'language': language,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * refresh browse structure cache
     * @returns string Accepted
     * @throws ApiError
     */
    public refreshBrowseCache({
        country,
    }: {
        country: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/refresh-cache',
            query: {
                'country': country,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

}
